import { Module } from 'vuex'
import axios from '@/plugins/axios'
import { sortCollection } from '@/utils/collections'

export interface ToneOfVoice {
    username: string
    token: string
}

const toneOfVoiceModule: Module<any, any> = {
    actions: {
        async initToneOfVoiceIndex() {
            if (this.toneOfVoiceIndexLoading) {
        		await this.initToneOfVoicePromise
        		return
        	}
            this.toneOfVoiceIndexLoading = true
            this.initToneOfVoicePromise = this.dispatch('initIndex', {
                id: 'toneOfVoice',
                idField: 'slug',
                indexedFields: ['name'],
                source: '/api/tone_of_voice',
                refresh: true,
            })
            await this.initToneOfVoicePromise
            this.toneOfVoiceIndexLoading = false
            this.initToneOfVoicePromise = null
        },
        
        async getToneOfVoices(_, params) {
            const indexExists = await this.dispatch('indexExists', 'toneOfVoice')
            if (!indexExists || params?.refresh) {
                await this.dispatch('initToneOfVoiceIndex')
            }

            const slugsFilter = (items) => {
                const filter = params.slugs
                return filter
                    ? items?.filter((e) => filter.includes(e.slug))
                    : items
            }

            const sentimentFilter = (items) => {                
                const filter = params.sentiment
                return filter
                    ? (filter === 'positive' ? items?.filter((e) => e.isPositive) : (filter === 'negative' ? items?.filter((e) => e.isNegative) : items))
                    : items
            }

            const sortName = (items) => {
                return sortCollection(items, 'name', params?.sortOrder?.toLowerCase() === 'asc')
            }

            const getSortOrder = () => {                
                return sortName
            }

            let records = null
            records = await this.dispatch('getRecords', {
                index: 'toneOfVoice',
                term: params?.search,
                fields: ['name'],
                page: params?.page ?? 1,
                perPage: params?.perPage ?? 10,
                filters: [slugsFilter, sentimentFilter],
                sort: getSortOrder(),
            })

            return records
        },

        async getToneOfVoicesFresh(_, params){
            let data = null
            await axios.get('/api/tone_of_voice',{params}).then((response) => {
                data = response.data
            })

            return data
        },
    },
}

export default toneOfVoiceModule
